import MatchCard from "./MatchCard";

export default MatchCard;